"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.acquisition_score = exports.feedbackType = exports.funnelType = exports.installationProfile2 = exports.installationProfile = exports.connectionType = exports.durationInYears = exports.energyType = exports.bannerType = exports.unit = exports.gas_installation_profile = exports.electricity_installation_profile = exports.segment_type = exports.channel = exports.brand = exports.duration2 = exports.acquisitionSegment = exports.loyaltyDiscountLevel = exports.contractTypeGas = exports.contractTypeElectricity = exports.customerStatus = exports.contractType = exports.acquisition_score_sme = exports.acquisitionScore = exports.churnRisk = exports.customerPhase = exports.id = exports.segmentType = exports.communicationMix = exports.duration = exports.momentOffsetUnit = exports.moment = exports.type2 = exports.productType = exports.type = exports.tariffKind = void 0;
/**
 * The tariff kind on the product
 */
exports.tariffKind = {
    DYNAMIC: 'dynamic',
    FIXED: 'fixed',
    VARIABLE: 'variable'
};
/**
 * Proposition product type
 */
exports.type = {
    GAS: 'gas',
    ELECTRICITY: 'electricity'
};
/**
 * Product type the incentive is for
 */
exports.productType = {
    GAS: 'gas',
    ELECTRICITY: 'electricity'
};
/**
 * Type of settlement for the incentive
 */
exports.type2 = {
    DISCOUNT_EUR: 'discount_eur',
    DISCOUNT_UNIT_EUR: 'discount_unit_eur',
    DISCOUNT_STATIC_PCT: 'discount_static_pct',
    DISCOUNT_TOTAL_PCT: 'discount_total_pct',
    PHYSICAL: 'physical',
    CASHBACK: 'cashback',
    INFORMATION: 'information'
};
/**
 * When the settlement for the incentive activates
 */
exports.moment = {
    OFFER_ACCEPTED: 'offer_accepted',
    COOLDOWN_END: 'cooldown_end',
    CONTRACT_START: 'contract_start'
};
/**
 * Unit of the offset for the settlement activation
 */
exports.momentOffsetUnit = {
    DAYS: 'calendar_day',
    WORKDAYS: 'working_day',
    WEEKS: 'week',
    MONTHS: 'month',
    YEARS: 'year'
};
/**
 * The duration of the proposition. 'obt' is SAP code 99 and 'flex' is SAP code 98.
 */
exports.duration = {
    '1YEAR': '1_year',
    '2YEARS': '2_years',
    '3YEARS': '3_years',
    '5YEARS': '5_years',
    OBT: 'obt',
    FLEX: 'flex'
};
/**
 * Whether the proposition is above the line or below the line. Not used by the offerstore but returned to be backwards compatible.
 */
exports.communicationMix = {
    ATL: 'Above the line',
    BTL: 'Below the line'
};
/**
 * The segment type of the proposition. This can be different between propositions, depending on your request. Its only undefined in older propositions.
 */
exports.segmentType = {
    HH: 'household',
    SOHO: 'small_office_home_office',
    SME: 'small_medium_enterprise',
    SPEC: 'special',
    RENT: 'rentals'
};
/**
 * An indicator of the customer phase, churn risk and acquisition score.
 */
exports.id = {
    HIGH_VALUE_RENEWABLE_WITH_CHURN_RISK: 'renewal_valuable_customer_risk',
    UPSELL_WITH_MEDIUM_OR_HIGH_CHURN_OR_ACQ: 'upsell_valuable_customer_risk',
    VALUABLE_RENEWAL_WITH_LOW_RISK: 'renewal_valuable_customer_low_risk',
    NO_RESULT: 'no_result'
};
/**
 * The customer journey phase of the profile.
 */
exports.customerPhase = {
    NEW_CUSTOMER: 'new_customer',
    OTHER: 'other',
    FIXED: 'fixed',
    RENEWABLE: 'renewable',
    RENEWED: 'renewed',
    VARIABLE: 'variable',
    EX_CUSTOMER: 'ex_customer'
};
/**
 * The churn risk of the profile.
 */
exports.churnRisk = {
    VERY_LOW: 'very_low',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high'
};
/**
 * The acquisition score of the profile.
 */
exports.acquisitionScore = {
    VERY_LOW: 'very_low',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    VERY_HIGH: 'very_high'
};
/**
 * The acquisition score of the profile, if acquisition is done for SME.
 */
exports.acquisition_score_sme = {
    VERY_LOW: 'very_low',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    VERY_HIGH: 'very_high'
};
/**
 * The contract type of the profile.
 */
exports.contractType = {
    FIXED: 'fixed',
    DYNAMIC: 'dynamic',
    VARIABLE: 'variable'
};
/**
 * The customer status of the profile.
 */
exports.customerStatus = {
    PROSPECT: 'prospect',
    FUTURE: 'future',
    WAIT_FOR_DELIVERY_START: 'wait_for_delivery_start',
    WAIT_FOR_DEPOSIT: 'wait_for_deposit',
    ACTIVE: 'active',
    EX_CUSTOMER: 'ex_customer',
    BLACK: 'black'
};
/**
 * The contract type of the electricity product of the profile.
 */
exports.contractTypeElectricity = {
    FIXED: 'fixed',
    DYNAMIC: 'dynamic',
    VARIABLE: 'variable'
};
/**
 * The contract type of the gas product of the profile.
 */
exports.contractTypeGas = {
    FIXED: 'fixed',
    DYNAMIC: 'dynamic',
    VARIABLE: 'variable'
};
/**
 * Level of thuisvoordeel that this customer has
 */
exports.loyaltyDiscountLevel = {
    BRONZE: 'BRONZE',
    SILVER: 'SILVER',
    GOLD: 'GOLD'
};
/**
 * Acquisition segment for this customer
 */
exports.acquisitionSegment = {
    _VERY_LOW: 'Very Low',
    _LOW: 'Low',
    _MEDIUM: 'Medium',
    _HIGH: 'High',
    _VERY_HIGH: 'Very High',
    _ULTRA_HIGH: 'Ultra High',
    VERY_LOW: 'very_low',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    VERY_HIGH: 'very_high',
    ULTRA_HIGH: 'ultra_high'
};
/**
 * Proposition duration.
 */
exports.duration2 = {
    ONE: '1',
    TWO: '2',
    THREE: '3',
    FIVE: '5',
    FLEX: 'flex'
};
/**
 * Brand the offer is for
 */
exports.brand = {
    ENERGIEDIRECT: 'energiedirect',
    ESSENT: 'essent'
};
/**
 * Channel the offer is for
 */
exports.channel = {
    FACEBOOK: 'facebook',
    GOOGLE: 'google',
    PCW: 'pcw',
    APP: 'app',
    OPEN: 'open',
    MIJN: 'mijn',
    COCKPIT: 'cockpit',
    EMAIL: 'email',
    EXTERNAL_PARTNER: 'external_partner',
    OPEN_OR_EXTERNAL_PARTNER: 'open_or_external_partner',
    DAISYCON: 'daisycon',
    SALES_PORTAL: 'sales_portal',
    CHATBOT: 'chatbot'
};
/**
 * The type of segment the address falls in.
 */
exports.segment_type = {
    HH: 'household',
    SOHO: 'small_office_home_office',
    SME: 'small_medium_enterprise',
    SPEC: 'special',
    RENT: 'rentals'
};
/**
 * The profile of the electricity meter/installation.
 * heavily influences the supply rates. Describes the maximum usage of the building.
 * We try to find the profile if it is an existing customer, otherwise it will default to E1C.
 */
exports.electricity_installation_profile = {
    E1A: 'E1A',
    E1B: 'E1B',
    E1C: 'E1C',
    E2A: 'E2A',
    E2B: 'E2B'
};
/**
 * The profile of the gas meter/installation.
 * Describes the maximum usage of the building.
 * Heavily influences the supply rates.
 * We try to find the profile if it is an existing customer, otherwise it will default to G1A.
 */
exports.gas_installation_profile = {
    G1A: 'G1A',
    G2A: 'G2A'
};
/**
 * Unit of the tariff, actual value is in the `unitPrice` property.
 */
exports.unit = {
    EUR_PER_M3: '€/m3',
    EUR_PER_DAY: '€/dag',
    EUR_PER_KWH: '€/kWh',
    PERCENTAGE: '%',
    EUR: '€',
    M3: 'm3'
};
/**
 * To see whether banner is of type Informational or Offer.
 */
exports.bannerType = {
    OFFER: 'offer',
    ACTION: 'action'
};
/**
 * Enerty type of the product
 */
exports.energyType = {
    GAS: 'gas',
    ELECTRICITY: 'electricity'
};
/**
 * The duration in years of the product
 */
exports.durationInYears = {
    ONE: '1',
    TWO: '2',
    THREE: '3',
    FIVE: '5',
    FLEX: 'flex'
};
/**
 * Whether this connection is a gas or electricity connection
 */
exports.connectionType = {
    GAS: 'gas',
    ELECTRICITY: 'electricity'
};
/**
 * The profile of the gas meter/installation.
 * Describes the maximum usage of the building.
 * Heavily influences the supply rates.
 * We try to find the profile if it is an existing customer, otherwise it will default to G1A.
 */
exports.installationProfile = {
    G1A: 'G1A',
    G2A: 'G2A'
};
/**
 * The profile of the electricity meter/installation.
 * heavily influences the supply rates. Describes the maximum usage of the building. Also determines if single or double meter is used in tariff calculations.
 * We try to find the profile if it is an existing customer, otherwise it will default to E1C.
 */
exports.installationProfile2 = {
    E1A: 'E1A',
    E1B: 'E1B',
    E1C: 'E1C',
    E2A: 'E2A',
    E2B: 'E2B'
};
/**
 * Funnel type for the returned offers, can be either 'acquisition' or 'retention'
 */
exports.funnelType = {
    ACQUISITION: 'acquisition',
    RETENTION: 'retention',
    RETENTIONN: 'RETENTION'
};
/**
 * The type of feedback
 */
exports.feedbackType = {
    REJECTED: 'rejected',
    CLICKED: 'clicked',
    SHOWN: 'shown',
    RETURNED: 'returned'
};
/**
 * The acquisition score of this profile.
 */
exports.acquisition_score = {
    VERY_LOW: 'very_low',
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
    VERY_HIGH: 'very_high'
};
